import React from 'react';
import { useAdresse } from '../queries/query-hooks';
import { AdresseError } from './AdresseError';
import { LoadingDots, Text } from '@mattilsynet/mt-ui';
import { PrivatPersonAdresseInfo } from './PrivatPersonAdresseInfo';
import { VirksomhetAdresseInfo } from './VirksomhetAdresseInfo';
import { AdresseQueryPayload } from '../types';
interface IAdresseProps {
  payload: AdresseQueryPayload;
}
export const Adresse = ({
  payload
}: IAdresseProps) => {
  const {
    data,
    isError,
    isLoading,
    refetch
  } = useAdresse(payload);
  const {
    adresse,
    beliggenhetsadresse,
    postadresse
  } = data ?? {};
  const hasAdresse = !(beliggenhetsadresse && Object.keys(beliggenhetsadresse).length === 0 || adresse && Object.keys(adresse).length === 0);
  if (isError) return <AdresseError refetch={() => refetch()} />;
  if (isLoading) return <LoadingDots />;
  if (!hasAdresse) return <Text>Ingen registrert adresse</Text>;
  if (adresse) return <PrivatPersonAdresseInfo tittel="Adresse" adresse={adresse} />;
  return <VirksomhetAdresseInfo beliggenhetsadresse={beliggenhetsadresse} postadresse={postadresse} data-sentry-element="VirksomhetAdresseInfo" data-sentry-component="Adresse" data-sentry-source-file="index.tsx" />;
};